import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { apiFetch, type ApiError } from "../../lib/api.ts";
import type { DiscoveredPage, DiscoveredStatus } from "./discovered-client.ts";

/**
 * The read for the Discovered agents screen (G1 #137): `GET /discovered-agents` as the operator's own role
 * (viewer is enough). It polls every 30 s through the shared query client, because the inventory is fed by
 * a queue and is "updated within a minute of the refusal"; there is no stream topic for it.
 */
export const DISCOVERED_QUERY_ROOT = ["discovered-agents"] as const;
export const DISCOVERED_POLL_MS = 30_000;
export const DISCOVERED_PAGE_SIZE = 50;

export function useDiscovered(status: DiscoveredStatus, cursor: string | null): UseQueryResult<DiscoveredPage, ApiError> {
  return useQuery<DiscoveredPage, ApiError>({
    queryKey: [...DISCOVERED_QUERY_ROOT, status, cursor ?? "first"],
    queryFn: ({ signal }) =>
      apiFetch<DiscoveredPage>("/discovered-agents", {
        query: { status, limit: DISCOVERED_PAGE_SIZE, ...(cursor === null ? {} : { cursor }) },
        signal,
      }),
    refetchInterval: DISCOVERED_POLL_MS,
    // Keep the previous page on screen while the next one of the SAME status loads; never show another
    // status's rows under this tab's label.
    placeholderData: (previous, previousQuery) => (previousQuery?.queryKey[1] === status ? previous : undefined),
  });
}
